import React from "react";
import searcher from "../../../assets/icons/searchInput.svg";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import RejectedInvoiceListListTable from "./rejected-invoice-list-table";

const RejectedInvoiceList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";

  return (
    <MainLayout breadCrumb="ADMIN  /  Verified Invoices">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} color={""} />
            <input
              value={search}
              className="search-input fs_14 text-dark fw_400 px-2"
              type="text"
              placeholder="Search Invoices here by Invoice ID, Customer Name, Field Force User Name, Distributor Name..."
              onChange={(e) => {
                navigate(
                  `/invoice-verification/rejected-invoicess?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                );
              }}
            />
          </div>
        </div>
        <RejectedInvoiceListListTable search={search} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default RejectedInvoiceList;
